<div class="uk-section ">
    <div class="uk-container uk-flex-center">
        <div class="uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div  uk-lightbox="animation: fade">
             
                    <a class="uk-inline" href="assets/portfolio/chat5.jpg" data-caption="Signup">
                        <img src="assets/portfolio/chat5.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                    </a>
                </div>
           
            <div  uk-lightbox="animation: fade">
             
                    <a class="uk-inline" href="assets/portfolio/chat3.jpg" data-caption="Home">
                        <img src="assets/portfolio/chat3.jpg" style="height: 500px; width: 400px;" alt="chatapp" uk-img></a>
                </div>
          
            <div   uk-lightbox="animation: fade">
                
                    <a class="uk-inline" href="assets/portfolio/chat4.jpg" data-caption="Search by name">
                        <img src="assets/portfolio/chat4.jpg" style="height: 500px; width: 400px;" alt="chatapp" uk-img></a>
               
            </div>
            <div uk-lightbox="animation: fade">
                
                    <a class="uk-inline" href="assets/portfolio/chat2.jpg" data-caption="Chats">
                        <img src="assets/portfolio/chat2.jpg" style="height: 500px; width: 400px;" alt="chatapp" uk-img></a>
               
            
       
    </div>
</div>
